<template>
  <div>
    <h2 class="mb-4 text-center">Sign up</h2>
    <sign-up2-form formType="jwt"></sign-up2-form>
  </div>
</template>
<script>
import SignUp2Form from './Forms/SignUp2Form'

export default {
  name: 'SignUp1',
  components: { SignUp2Form },
  data: () => ({}),
  methods: {}
}
</script>
